module.exports = __webpack_public_path__ + "img/logo-small.8a7ff884.png";